export const af = {
    LEFT: 'Links: Skuif na die vorige dag.',
    RIGHT: 'Regs: Beweeg na die volgende dag.',
    DOWN: 'Af: Beweeg na die volgende ry.',
    UP: 'Up: Skuif na die vorige ry.',
    PGUP: 'PgUp: Skuif na die vorige maand.',
    PGDOWN: 'PgDown: Skuif na die volgende maand.',
    HOME: 'Huis: Skuif na die vorige jaar.',
    END: 'Einde: Skuif na die volgende jaar.',
    ESC: 'Esc/Vandag/Van: van die jaarboek.',
    TITLE: 'Sleutelbord Instruksies'
};
